/*
 * Operaciones de edición del formulario, aplicadas EN EL CLIENTE.
 *
 * Son las mismas que recibe `POST /forms/{id}/cambios` (contrato: email/claude/formularios.md). El editor
 * las aplica al momento sobre su copia (la persona ve el cambio sin esperar a la red) y las manda en lote;
 * cuando el servidor contesta, su versión manda y se le vuelven a aplicar las que se escribieron mientras
 * tanto. Por eso esto tiene que hacer exactamente lo mismo que el servidor, o la pantalla "saltaría".
 */

const RUTAS_FUSION = new Set(['tema', 'ajustes']);

const esObjeto = (x) => !!x && typeof x === 'object' && !Array.isArray(x);

function fusionar(base, cambio) {
  if (!esObjeto(cambio)) return cambio;
  const out = { ...(esObjeto(base) ? base : {}) };
  Object.entries(cambio).forEach(([k, v]) => {
    out[k] = esObjeto(v) ? fusionar(out[k], v) : v;
  });
  return out;
}

/** Posición donde insertar "después de `id`": null = al principio; un id que ya no existe = al final. */
function posicion(items, despuesDe) {
  if (despuesDe === null || despuesDe === undefined) return 0;
  const i = items.findIndex((it) => it.id === despuesDe);
  return i >= 0 ? i + 1 : items.length;
}

export function aplicarOps(formulario, ops) {
  if (!formulario || !ops?.length) return formulario;
  const f = { ...formulario, items: [...(formulario.items || [])] };
  ops.forEach((op) => {
    switch (op.op) {
      case 'set':
        // `nombre` es del archivo de Drive, no del formulario: lo refleja el hook en `archivo`
        if (op.ruta === 'nombre') break;
        f[op.ruta] = RUTAS_FUSION.has(op.ruta) ? fusionar(f[op.ruta], op.valor) : op.valor;
        break;
      case 'item_add':
        if (!op.item || f.items.some((it) => it.id === op.item.id)) break;
        f.items.splice(posicion(f.items, op.despues_de), 0, op.item);
        break;
      case 'item_set':
        f.items = f.items.map((it) => (it.id === op.id ? { ...it, ...(op.campos || {}) } : it));
        break;
      case 'item_del':
        f.items = f.items.filter((it) => it.id !== op.id);
        break;
      case 'item_move': {
        const i = f.items.findIndex((it) => it.id === op.id);
        if (i < 0 || op.despues_de === op.id) break;
        const [movido] = f.items.splice(i, 1);
        f.items.splice(posicion(f.items, op.despues_de), 0, movido);
        break;
      }
      case 'items':
        f.items = [...(op.items || [])];
        break;
      default:
        break;
    }
  });
  return f;
}

/**
 * Junta operaciones seguidas sobre lo mismo (cada tecla de un título es un `item_set`): menos bytes
 * por la red y el servidor aplica una sola. Solo junta VECINAS, para no alterar el orden de lo demás.
 */
export function compactar(ops) {
  const out = [];
  (ops || []).forEach((op) => {
    const previa = out[out.length - 1];
    if (previa && previa.op === 'item_set' && op.op === 'item_set' && previa.id === op.id) {
      out[out.length - 1] = { ...previa, campos: { ...previa.campos, ...op.campos } };
      return;
    }
    if (previa && previa.op === 'set' && op.op === 'set' && previa.ruta === op.ruta) {
      out[out.length - 1] = RUTAS_FUSION.has(op.ruta) ? { ...op, valor: fusionar(previa.valor, op.valor) } : op;
      return;
    }
    out.push(op);
  });
  return out;
}

/** Lo que guarda el historial de deshacer: el contenido, no los ajustes ni el tema. */
export const fotoDe = (f) => ({
  titulo: f?.titulo || '',
  descripcion: f?.descripcion || '',
  despues_primera: f?.despues_primera || 'siguiente',
  items: f?.items || [],
});

export const opsDeFoto = (foto) => [
  { op: 'items', items: foto.items },
  { op: 'set', ruta: 'titulo', valor: foto.titulo },
  { op: 'set', ruta: 'descripcion', valor: foto.descripcion },
  { op: 'set', ruta: 'despues_primera', valor: foto.despues_primera },
];
